import React, { useEffect } from 'react'
import { CCol, CWidgetDropdown, CSpinner } from '@coreui/react'
import { getStyle } from '@coreui/utils'
import { CChartLine } from '@coreui/react-chartjs'
import CIcon from '@coreui/icons-react'
import { cilArrowBottom, cilArrowTop } from '@coreui/icons'
import { formatBytes } from 'src/views/utils/helper'
import useAxios from 'axios-hooks'
import { RAVEN_ANALYTICS_API } from 'src/views/utils/urls'

const BandwidthCard = ({ getDateLabels }) => {
  const [{ data: bandwidthData }, bandwidthDataCall] = useAxios(
    {
      url: `${RAVEN_ANALYTICS_API}/bandwidth-card`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    bandwidthDataCall({
      params: {
        delta_window: 90,
        unit_window: 15,
        num_data_points: 12,
      },
    })
  }, [])
  return (
    <CCol sm={6} lg={3}>
      <CWidgetDropdown
        className="mb-4"
        color="danger"
        value={
          bandwidthData?.data ? (
            formatBytes(bandwidthData?.data?.bandwidth_used)
          ) : (
            <CSpinner color="light" />
          )
        }
        change={
          bandwidthData?.data && (
            <>
              ( {Number(bandwidthData?.data?.percentage_delta).toFixed(1)}%
              {bandwidthData?.data?.percentage_delta > 0 ? (
                <CIcon icon={cilArrowTop} />
              ) : (
                <CIcon icon={cilArrowBottom} />
              )}
              )
            </>
          )
        }
        title="Bandwidth Consumed"
        chart={
          <CChartLine
            className="mt-3 mx-3 pb-1"
            style={{ height: '70px' }}
            data={{
              labels: getDateLabels(2, 12),
              datasets: [
                {
                  label: 'Bandwidth Used (GB)',
                  backgroundColor: 'rgba(255,255,255,.2)',
                  borderColor: 'rgba(255,255,255,.55)',
                  pointBackgroundColor: getStyle('--cui-danger'),
                  data: bandwidthData?.data?.data_points.map((val) =>
                    Number(val / Math.pow(1024, 3)).toFixed(2),
                  ),
                  fill: true,
                },
              ],
            }}
            options={{
              plugins: {
                legend: {
                  display: false,
                },
              },
              maintainAspectRatio: false,
              scales: {
                x: {
                  display: false,
                },
                y: {
                  display: false,
                },
              },
              elements: {
                line: {
                  borderWidth: 1,
                  tension: 0.4,
                },
                point: {
                  radius: 4,
                  hitRadius: 10,
                  hoverRadius: 4,
                },
              },
            }}
          />
        }
      />
    </CCol>
  )
}

export default BandwidthCard
